import formatNumberToCurrency from './NumberUtil';

/* Util functions working with Cost Breakdown in Single Estimate Page */

/* Returns number formatted value for Applied to Deductible */
export const getAppliedToDeductible = (singleEstimateResponse) => {
    return singleEstimateResponse &&
        (singleEstimateResponse?.costShare?.appliedToDeductible ||
            singleEstimateResponse?.costShare?.appliedToDeductible == 0)
        ? formatNumberToCurrency(
              singleEstimateResponse?.costShare?.appliedToDeductible,
              singleEstimateResponse?.costShare?.outOfPocket
          )
        : '$ --';
};

/* Returns number formatted value for CoPay */
export const getCoPay = (singleEstimateResponse) => {
    return singleEstimateResponse &&
        (singleEstimateResponse?.costShare?.copay || singleEstimateResponse?.costShare?.copay == 0)
        ? formatNumberToCurrency(
              singleEstimateResponse?.costShare?.copay,
              singleEstimateResponse?.costShare?.outOfPocket
          )
        : '$ --';
};

/* Returns number formatted value for CoInsurance */
export const getCoinsurance = (singleEstimateResponse) => {
    return singleEstimateResponse &&
        (singleEstimateResponse?.costShare?.coinsurance ||
            singleEstimateResponse?.costShare?.coinsurance == 0)
        ? formatNumberToCurrency(
              singleEstimateResponse?.costShare?.coinsurance,
              singleEstimateResponse?.costShare?.outOfPocket
          )
        : '$ --';
};

/** Returns the appropriate number for "you pay" value.
 * Usually this is the costshare's Out of Pocket
 * But UMR is a special case
 * UMR is always a special case
 * @param {object} singleSCP - either scenario, claim, or procedure since each object has a costShare object
 */

export const getMemberPays = (singleSCP, defaultValue = '$ --') => {
    // when a rate of zero comes back typically means the provider is not contracted through the member's insurance
    // and therefore we should display "Not Covered"
    if (singleSCP?.costShare?.rate == 0) {
        return 'Not Covered';
    }
    return singleSCP?.costShare?.outOfPocket || singleSCP?.costShare?.outOfPocket == 0
        ? formatNumberToCurrency(
              singleSCP?.costShare?.outOfPocket,
              singleSCP?.costShare?.outOfPocket
          )
        : defaultValue;
};

export const getTotalBeforeCoverage = (singleEstimate, defaultValue = '$ --') => {
    if (
        singleEstimate.costShare?.insurancePays ||
        singleEstimate.costShare?.insurancePays == 0 ||
        singleEstimate.costShare?.outOfPocket ||
        singleEstimate.costShare?.outOfPocket == 0
    ) {
        return formatNumberToCurrency(
            singleEstimate.costShare?.insurancePays + singleEstimate.costShare?.outOfPocket,
            singleEstimate?.costShare?.outOfPocket
        );
    } else {
        return defaultValue;
    }
};
